import { builder, defaults } from 'common/js/configs';

export const formatConfigUnmarshaller = {
  browser: defaults.browser,
  formatBaseUrl: builder.string('format_base_url', { optional: true }),
  clickUrl: builder.string('click_url', { optional: true }),
  displayTrackers: defaults.displayTrackers,
  mrc50ImgTrackers: defaults.mrc50ImgTrackers,
  mrc50JsTrackers: defaults.mrc50JsTrackers,
  mrc100ImgTrackers: defaults.mrc100ImgTrackers,
  mrc100JsTrackers: defaults.mrc100JsTrackers,
  locale: defaults.locale,
  analytics: defaults.analytics,
  omid: defaults.omid,
  forceResponsiveHtml: builder.boolean('force_responsive_html', {
    l:'',
    defaultValue: false,
    d:''
  }),
  shouldRefreshFrameOnRotation: builder.boolean('refresh_frame_on_rotation', {
    l:'',
    d:'',
    defaultValue: false
  }),
  isMraidCompliant: builder.boolean('is_mraid_compliant', {
    l:'',
    d:'',
    defaultValue: true
  }),
  isOgurySdk: builder.boolean('is_ogury_sdk', {
    l:'',
    d:'',
    defaultValue: true
  })
};

export interface DisplayCommonConfigType extends FormatConfigType<unknown> {
  browser: BrowserConfigType;
  clickUrl: string;
  analytics: boolean;
  displayTrackers: DisplayTrackersConfigType;
  mrc50ImgTrackers: Array<string>;
  mrc50JsTrackers: Array<string>;
  mrc100ImgTrackers: Array<string>;
  mrc100JsTrackers: Array<string>;
  closeBtn: CloseBtnConfigType;
  icon: IconConfigType;
  optoutBtn: OptoutBtnConfigType;
  shouldRefreshFrameOnRotation: boolean;
  triggerImpressionAfterPreload: boolean;
}
